module.exports = __webpack_public_path__ + "static/bml-logo-580a070da418644fa00340b429fa4c45.jpg";